import { EtcChildOptionValueEnum } from '@constant';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStoreEtc } from '@types';

const initialState: IStoreEtc = Object.fromEntries(
  Object.values(EtcChildOptionValueEnum).map((value) => [value, true])
);

export const etcSlice = createSlice({
  name: 'etc',
  initialState,
  reducers: {
    initEtc: () => {
      return initialState;
    },

    setEtc: (state, action: PayloadAction<IStoreEtc>) => {
      return { ...state, ...action.payload };
    }
  }
});

export const { initEtc, setEtc } = etcSlice.actions;

export default etcSlice.reducer;
